import React from 'react'; 
import PageText from './PageText';
import PageImage from './PageImage';
import PageTeam from './PageTeam';
import PageAwards from './PageAwards';
import PageAccordions from './PageAccordions';
import PageLargeText from './PageLargeText';
import PageFeatured from './PageFeatured';
import PageHomes from './PageHomes';
import PageSplash from './PageSplash';
import PageProjects from './PageProjects';
import PageContact from './PageContact';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context}) => {
 	
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
		
		if (block.type == 'large_text') {
		
		    content = <PageLargeText block={block}></PageLargeText>
		
		} else if (block.type == 'text') {
			
			content = <PageText block={block}></PageText>
			
		} else if (block.type == 'image') {
			
			content = <PageImage block={block}></PageImage>
			
		} else if (block.type == 'team') {
			
			content = <PageTeam block={block}></PageTeam>
			
		} else if (block.type == 'awards') {
			
			content = <PageAwards block={block}></PageAwards>
			
		} else if (block.type == 'featured_projects') {
			
			content = <PageFeatured block={block}></PageFeatured>
			
		} else if (block.type == 'featured_homes') {
			
			content = <PageHomes block={block}></PageHomes>
			
		} else if (block.type == 'accordions') {
			
			content = <PageAccordions block={block}></PageAccordions>
			
		} else if (block.type == 'accordions') {
			
			content = <PageAccordions block={block}></PageAccordions>
			
		} else if (block.type == 'splash') {
			
			content = <PageSplash block={block}></PageSplash>
			
		} else if (block.type == 'projects') {
			
			content = <PageProjects block={block}></PageProjects>
			
		} else if (block.type == 'contact') {
			
			content = <PageContact post={post} block={block}></PageContact>
			
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);